export default "__VITE_ASSET__CVLu$hRL__"